import { Box, styled } from '@mui/material'

export const EmptyIndicatorWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  rowGap: theme.spacing(1),
}))
